import React from 'react';

import { Box } from '~/eds/src/components/Box/Box';
import { CollapsibleText } from '~/eds/src/components/CollapsibleText/CollapsibleText';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { Mark } from '~/eds/src/components/Mark/Mark';
import { PilotId } from '~/eds/src/types/PilotId';
import { ClauseContent } from '~/types/Clause';

interface Props {
  activeClauseId?: PilotId;
  clauses: ClauseContent[];
  onClick?: (clause: ClauseContent) => void;
}

export const Clause = ({ activeClauseId, clauses, onClick }: Props) => {
  return (
    <Layout direction="column">
      {clauses.map((clause) => {
        const isActive = clause.id === activeClauseId;
        const Component = (
          <Box
            aria-current={isActive ? 'true' : undefined}
            onClick={() => onClick?.(clause)}
            key={clause.id}
            px={6}
            py={4}
            role="listitem"
          >
            <CollapsibleText
              key={clause.id}
              text={clause.content}
              limit={180}
            />
          </Box>
        );

        return isActive ? (
          <Mark key={clause.id} highlighter="ai" isActive>
            {Component}
          </Mark>
        ) : (
          Component
        );
      })}
    </Layout>
  );
};
